import {
  BOSS_DEFEATED,
  GET_BOSS_RANKS,
  SET_AMULETS,
  SET_POWER_SEARH,
  SET_REMEMBERS,
  STAGE_COMPLETED,
} from '../actions/types';

const amulets = JSON.parse(window.localStorage.getItem('amulets')) || [];
const remembers = JSON.parse(window.localStorage.getItem('remembers')) || [];
const initialState = {
  searchPower: null,
  amulets,
  remembers,
  stageCompletedValue: null,
  bossDefeatedValue: null,
  bossRanks: null,
  passQuestions: [],
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_POWER_SEARH:
      return { ...state, searchPower: payload.searchPower };
    case SET_AMULETS:
      return { ...state, amulets: payload };
    case SET_REMEMBERS:
      return { ...state, remembers: payload };
    case BOSS_DEFEATED:
      return {
        ...state,
        bossDefeatedValue: payload ? { stageId: payload.stageId } : null,
      };
    case STAGE_COMPLETED:
      return {
        ...state,
        stageCompletedValue: payload ? { stageId: payload.stageId } : null,
      };
    case GET_BOSS_RANKS:
      return {
        ...state,
        bossRanks: payload,
      };
    default:
      return state;
  }
}
